import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { getAllUserRoles } from "../slices/authSlice";

export const useRoles = () => {
    const dispatch = useAppDispatch();
    const { roles, error } = useAppSelector((state) => state.auth);

    useEffect(() => {
        if (!roles || roles.length === 0) {
            dispatch(getAllUserRoles());
        }
    }, [dispatch, roles]);

  return { roles, error };
};